import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectProductState = (state: RootState) => state.product;

const selectProductList = createSelector(
  selectProductState,
  (state) => state.products
);

const selectProductsMeta = createSelector(
  selectProductState,
  (state) => state.productsMeta
);

const selectPriceList = createSelector(
  selectProductState,
  (state) => state.priceList
);

const selectPriceListDate = createSelector(
  selectProductState,
  (state) => state.priceListDate
);

const selectPriceListColumns = createSelector(
  selectProductState,
  (state) => state.productTableColumns
);

const selectPriceListParams = createSelector(
  selectProductState,
  (state) => state.priceListParams
);

const selectProductPriceList = createSelector(
  selectProductState,
  (state) => state.productPriceList
);

const selectProductPriceListMeta = createSelector(
  selectProductState,
  (state) => state.priceListMeta
);

const selectIsProductPriceListLoading = createSelector(
  selectProductState,
  (state) => state.isPriceListLoading
);

const selectPoweredBuildsComponent = createSelector(
  selectProductState,
  (state) => state.componentProductsState
);

export const selectors = {
  selectProductList,
  selectPriceList,
  selectPriceListDate,
  selectPriceListColumns,
  selectPriceListParams,
  selectProductPriceList,
  selectProductPriceListMeta,
  selectIsProductPriceListLoading,
  selectProductsMeta,
  selectPoweredBuildsComponent
};
